import { api } from "./api";
import { url } from "../config";

export const divisionListApi = (params) => {
  return api.get("/manufacturer/division/list", { params: params });
};

export const divisionDetailApi = (params) => {
  return api.get(
    `/manufacturer/division/view?division_id=${params.division_id}`
  );
};

export const productDivisionListApi = (params) => {
  return api.get(`/manufacturer/division/products`, { params: params });
};

export const ffDivisionListApi = (params) => {
  return api.get(`/manufacturer/division/field-force-users`, {
    params: params,
  });
};

export const doctorCreateApi = (params) => {
  return api.post(
    `/manufacturer/division/create-doctor`,
    JSON.stringify(params)
  );
};

export const pharmacyCreateApi = (params) => {
  return api.post(
    `/manufacturer/division/create-pharmacy`,
    JSON.stringify(params)
  );
};

export const doctorDivisionListApi = (params) => {
  return api.get(`/manufacturer/division/doctors`, {
    params: params,
  });
};

export const pharmacyDivisionListApi = (params) => {
  return api.get(`/manufacturer/division/pharmacies`, {
    params: params,
  });
};

export const doctorDivViewApi = (params) => {
  return api.get(`/manufacturer/division/doctor/view`, {
    params: params,
  });
};

export const pharmacyDivViewApi = (params) => {
  return api.get(`/manufacturer/division/pharmacy/view`, {
    params: params,
  });
};

export const reimbursementListApi = (params) => {
  return api.get(`/manufacturer/division/reimbursement-list`);
};

export const createDivisionApi = (params) => {
  return api.post(`/manufacturer/division/create`, JSON.stringify(params));
};

export const editDivisionApi = (params) => {
  return api.post(`/manufacturer/division/edit`, JSON.stringify(params));
};

export const enableDisableDivisionApi = (params) => {
  return api.post(
    `/manufacturer/division/enable-disable`,
    JSON.stringify(params)
  );
};

// BULK UPLOAD

export const productCsvUploadApi = (params, file) => {
  return api.post(`/manufacturer/division/upload-product?`, file, {
    params,
    headers: { "Content-Type": "multipart/form-data" },
    baseURL: url,
  });
};

export const productBulkVerify = (params) => {
  return api.post(
    `/manufacturer/division/verify-product`,
    JSON.stringify(params)
  );
};
export const fieldForceCsvUploadApi = (params, file) => {
  return api.post(`/manufacturer/division/upload-field-force`, file, {
    params,
    headers: { "Content-Type": "multipart/form-data" },
    baseURL: url,
  });
};

export const fieldForceBulkVerify = (params) => {
  return api.post(
    `/manufacturer/division/verify-field-force-user`,
    JSON.stringify(params)
  );
};

export const distributorCSVUploadApi = (params, file) => {
  return api.post(`/manufacturer/division/upload-distributor`, file, {
    params,
    headers: { "Content-Type": "multipart/form-data" },
    baseURL: url,
  });
};
export const distributorBulkVerify = (params) => {
  return api.post(
    `/manufacturer/division/verify-distributor`,
    JSON.stringify(params)
  );
};
export const doctorCSVUploadApi = (params, file) => {
  return api.post(`/manufacturer/division/upload-doctor`, file, {
    params,
    headers: { "Content-Type": "multipart/form-data" },
    baseURL: url,
  });
};
export const doctorBulkVerify = (params) => {
  return api.post(
    `/manufacturer/division/verify-doctor`,
    JSON.stringify(params)
  );
};
export const pharmacyCSVUploadApi = (params, file) => {
  return api.post(`/manufacturer/division/upload-pharmacy`, file, {
    params,
    headers: { "Content-Type": "multipart/form-data" },
    baseURL: url,
  });
};
export const pharmacyBulkVerify = (params) => {
  return api.post(
    `/manufacturer/division/verify-pharmacy`,
    JSON.stringify(params)
  );
};
